import React, { useCallback, useEffect, useState } from "react";
import {
  AccordionContent,
  AccordionTitle,
  Checkbox,
  Icon,
} from "semantic-ui-react";
import { spacing } from "../library";
import { typographyColors } from "../library/theme";
import MockLevelFieldGroupItem from "./MockLevelFieldGroupItem";
import { useSelector } from "react-redux";
import { selectLevelOptions } from "@/lms/selectors/levelSelectors";
import { css } from "glamor";

const container = {
  display: "flex",
  gap: spacing.s,
};

const accordionTitleStyle = {
  padding: 0,
  fontSize: 16,
  fontFamily: "inherit",
};

const hintClass = {
  display: "inline",
  color: typographyColors.defaultBody,
  marginLeft: spacing.xxs,
};

const accordionContentStyle = {
  marginTop: spacing.s,
};

export default function MockLevelFieldGroup({
  index,
  parentLevelOption,
  fields,
  disabled,
  setIsAllSelected,
  chosenOption,
  selectedFields,
}) {
  const levelOptions =
    useSelector((state) => selectLevelOptions(state, chosenOption.id)) || [];
  const childLevelOptions = levelOptions?.filter(
    (childLevelOption) => childLevelOption.sublevelId === parentLevelOption.id,
  );
  const selectedGroupFields = childLevelOptions.filter((option) =>
    selectedFields.includes(option.id),
  );

  const [activeAccordion, setActiveAccordion] = useState(false);
  const handleAccordionClick = useCallback(() => {
    setActiveAccordion(!activeAccordion);
  }, [activeAccordion]);

  const [isGroupSelected, setIsGroupSelected] = useState(false);

  const selectGroup = React.useCallback(() => {
    if (!fields || !childLevelOptions) return;
    setIsGroupSelected(true);
    childLevelOptions.forEach((option) => fields.push(option.id));
  }, [fields, selectedFields, childLevelOptions]);

  const deselectGroup = React.useCallback(() => {
    if (!fields || !childLevelOptions) return;
    setIsAllSelected(false);
    setIsGroupSelected(false);
    const fieldsToKeep = selectedFields.filter(
      (field) => !childLevelOptions.some((option) => option.id === field),
    );
    fields.removeAll();
    fieldsToKeep.forEach((field) => fields.push(field));
  }, [fields, selectedFields, childLevelOptions]);

  const handleSelectGroupClick = isGroupSelected ? deselectGroup : selectGroup;

  useEffect(() => {
    if (selectedGroupFields.length > 0) {
      setIsGroupSelected(true);
    } else if (selectedGroupFields.length === 0) {
      setIsGroupSelected(false);
    }
  }, [selectedGroupFields.length]);

  return (
    childLevelOptions.length > 0 && (
      <div style={container}>
        <Checkbox onClick={handleSelectGroupClick} checked={isGroupSelected} />

        <div>
          <AccordionTitle
            style={accordionTitleStyle}
            active={activeAccordion}
            index={index}
            onClick={handleAccordionClick}
          >
            {parentLevelOption.name}
            <div className={css(hintClass)}>{parentLevelOption.hint}</div>
            <Icon name="dropdown" />
          </AccordionTitle>

          <AccordionContent
            style={accordionContentStyle}
            active={activeAccordion}
          >
            {childLevelOptions.map((childLevelOption) => (
              <MockLevelFieldGroupItem
                key={childLevelOption.id}
                level={childLevelOption}
                setIsAllSelected={setIsAllSelected}
                fields={fields}
                disabled={disabled}
              />
            ))}
          </AccordionContent>
        </div>
      </div>
    )
  );
}
